import { getEntityRef } from "@client/content/lib/helper";
import { getReferringUserId } from "@client/lib/cookie";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import { applyNow } from "../../actions";
import { localStateSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  caption: "",

  isVisible: false
};
const makeMapStateToProps = () => {
  const captionSelector = getSettingValueSelector(TargetSelector.Entity, "applyCaption");

  return (state: AppState, props: EntityRef): MapProps => {
    const localState = localStateSelector(state, props);

    if (localState.current || getReferringUserId()) return INVISIBLE_PROPS;

    return {
      ...props,
      caption: captionSelector(state, props),

      isVisible: true
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: EntityRef): ActionProps => ({
  onApply: () => dispatch(applyNow(getEntityRef(props)))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
